import Vue from 'vue';
import moment from 'moment-timezone';
import axios from 'axios';
import EventBus from '../../event-bus';

const JsSIP = require('jssip');

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
  config.metadata = { // eslint-disable-line
    start_at: moment.utc(),
  };
  return config;
}, error => Promise.reject(error));

axiosInstance.interceptors.response.use((response) => {
  response.config.metadata.end_at = moment.utc(); // eslint-disable-line
  response.config.metadata.duration = response.config.metadata.end_at.diff(response.config.metadata.start_at, 'seconds'); // eslint-disable-line
  return response;
}, error => Promise.reject(error));

export default {
  resetValues({ commit }) {
    commit('SET_CALL_CENTER_STATUS', 0);
    commit('callTimeAndAlert/SET_CURRENT_STATUS_START_TIME', 0, { root: true });
    commit('callTimeAndAlert/SET_STATUS_MANUAL_CALL', false, { root: true });
    commit('SET_CALL_LIST_ID', 0);
    commit('SET_CONFERENCE_ID', 0);
    commit('SET_NOTIFICATION', {});
    commit('SET_SOFT_PHONE', {});
    commit('SET_EXTENSION', {});
    commit('SET_CALL', {});
    commit('SET_EXTENSIONS', []);
    commit('SET_IS_RECORDING', false);
    commit('SET_CURRENT_RECORDING', {});
    commit('SET_CALL_TYPE', '');
    commit('SET_DISCONNECT_REASON', '');
    commit('SET_MAX_COMMITMENT_DAYS', null);
    commit('SET_RECONNECTING', false);
  },
  disconnectCallCenter({ state, commit, dispatch }) {
    return new Promise((resolve) => {
      let promise1 = Promise.resolve();
      if (state.callType !== 'manual') {
        promise1 = Vue.axios.post(`${process.env.LAMBDA_API_URL}/api/call_center/disconnect`, {
          user_id: Vue.auth.user().id,
          disconnect_reason: state.disconnectReason,
          notification_id: state.notification.id,
        });
      }
      promise1
        .then(() => {
          let promise = Promise.resolve();
          if (state.callType === 'predictive') {
            promise = dispatch('unregisterSoftPhone');
          }
          promise
            .then(() => {
              const { callListId } = state;
              const { callType } = state;
              dispatch('resetValues')
                .then(() => {
                  if (callType !== 'manual') {
                    Vue.router.push(`/calls_lists/${callListId}`);
                  } else {
                    EventBus.$emit('update');
                  }
                  resolve();
                });
            });
        }).catch(() => {
          EventBus.$emit('modal', 'Ocurrio un error, no se pudo desconectar.');
          commit('SET_KEEP_CALLING', true);
          commit('SET_DISCONNECT_REASON', '');
        });
    });
  },
  callFinished({ state, commit, dispatch }) {
    if ((state.callType !== 'manual') && state.keepCalling) {
      commit('SET_CALL_CENTER_STATUS', 1);
      commit('callTimeAndAlert/SET_CURRENT_STATUS_START_TIME', 0, { root: true });
      commit('SET_NOTIFICATION', {});
      commit('SET_CURRENT_RECORDING', {});
      commit('SET_IS_RECORDING', false);
      Vue.router.push('/calls_lists/wait');
    } else {
      dispatch('disconnectCallCenter');
    }
  },
  getFreeExtension() {
    return Vue.axios.get(`${process.env.LAMBDA_API_URL}/api/extensions/free`, {
      params: {
        user_id: Vue.auth.user().id,
        country_id: Vue.auth.user().country_id,
      },
    })
      .then((response) => {
        let result;
        if (response.data.message === 'no extensions avaliable') {
          EventBus.$emit('modal', 'No hay extensiones disponibles.');
        } else {
          result = response.data;
        }
        return result;
      })
      .catch((error) => {
        EventBus.$emit('modal', 'Ocurrio un error, espere unos minutos e intente nuevamente.');
        throw new Error(error);
      });
  },
  registerExtension(store, extension) {
    return new Promise((resolve, reject) => {
      const socket = new JsSIP.WebSocketInterface(`wss://${process.env.ASTERISK_HOST}/ws`);
      const softPhone = new JsSIP.UA({
        sockets: [
          socket,
        ],
        uri: `sip:${extension.extension}@${process.env.ASTERISK_HOST}`,
        password: extension.password,
        register: true,
      });
      softPhone.on('registered', () => {
        resolve(softPhone);
      });
      softPhone.on('registrationFailed', reject);
      softPhone.on('newRTCSession', (data) => {
        data.session.connection.addEventListener('addstream', (evt) => {
          const remoteAudio = document.createElement('audio');
          remoteAudio.srcObject = evt.stream;
          remoteAudio.play();
        });
      });
      softPhone.start();
    });
  },
  makeCall(store, { softPhone, phone, headers = [] }) {
    return softPhone.call(`sip:${phone}@${process.env.ASTERISK_HOST}`, {
      mediaConstraints: {
        audio: true,
        video: false,
      },
      ...headers.length && {
        extraHeaders: headers,
      },
    });
  },
  startCallCenter({ dispatch, commit }, body) {
    commit('SET_CALL_CENTER_STATUS', 1);
    commit('callTimeAndAlert/SET_CURRENT_STATUS_START_TIME', 0, { root: true });
    dispatch('callTimeAndAlert/getCallDurationData', null, { root: true });
    return Vue.axios.post(`${process.env.LAMBDA_API_URL}/api/call_center/start_v2`, {
      user_id: Vue.auth.user().id,
      country_id: Vue.auth.user().country_id,
      call_list_id: body.call_list_id,
      call_type: body.call_type,
      zoom_url: body.zoom_url,
      conference_id: body.conference_id,
      access_code: body.access_code,
      receive_incoming_calls: body.receive_incoming_calls,
      type: body.type,
      extension_number: body.extension_number,
      new_server: body.new_server,
    }).then((response) => {
      let result;
      if (response.data.message === 'successful operation') {
        result = response.data.body;
      } else if (response.data.message === 'no extensions avaliable') {
        commit('SET_CALL_CENTER_STATUS', 0);
        commit('callTimeAndAlert/SET_CURRENT_STATUS_START_TIME', 0, { root: true });
        EventBus.$emit('modal', 'No hay extensiones disponibles');
      } else {
        commit('SET_CALL_CENTER_STATUS', 0);
        commit('callTimeAndAlert/SET_CURRENT_STATUS_START_TIME', 0, { root: true });
        EventBus.$emit('modal', 'Ocurrio un error, espere unos minutos e intente nuevamente.');
      }
      return result;
    }).catch((error) => {
      commit('SET_CALL_CENTER_STATUS', 0);
      commit('callTimeAndAlert/SET_CURRENT_STATUS_START_TIME', 0, { root: true });
      if ((error.response || {}).status === 422) {
        EventBus.$emit('modal', 'Error, usuario conectado a llamada manual.');
      } else {
        EventBus.$emit('modal', 'Ocurrio un error, espere unos minutos e intente nuevamente.');
      }
      throw new Error(error);
    });
  },
  startSpyCall({ commit }, body) {
    return Vue.axios.post(`customers/spy_call`, {
      extension_number: body.extension_number,
      colekter_extension: body.colekter_extension,
    })
    .catch((error) => {
      EventBus.$emit('modal', 'Ocurrio un error, revise su microsip e intente nuevamente.');
      throw new Error(error);
    })
  },
  checkOperatorStatus({ state, commit, dispatch }) {
    axiosInstance.get(`${process.env.LAMBDA_API_URL}/api/call_center/user/${Vue.auth.user().id}`, {
      timeout: 15000,
    })
      .then((response) => {
        commit('SET_RECONNECTING', false);
        const agent = response.data.agent || {};
        let keepTrying = true;

        if (response.data.extensions) {
          commit('SET_EXTENSIONS', response.data.extensions);
        }

        const disconnectionCause = [
          1, // Inactividad
          10, // Tiene desconectado el microsip
        ]

        if (agent.status_id === 0 && disconnectionCause.includes((agent.disconnect_reason || {}).id)) {
          console.log('CALL CENTER ENTRO IF 1');
          keepTrying = false;
          let message = 'Desconectado por Inactividad';
          if ((agent.disconnect_reason || {}).id === 10) {
            message = 'Sin conexion con softphone';
          }
          EventBus.$emit('modal', message);
          commit('SET_KEEP_CALLING', false);
          const { callListId } = state;
          dispatch('resetValues')
            .then(() => {
              Vue.router.push(`/calls_lists/${callListId}`);
            });
        } else if (
          agent.status_id === 1
          && state.callCenterStatus === 3
        ) {
          console.log('CALL CENTER ENTRO IF 2');
          keepTrying = state.keepCalling;
          dispatch('callFinished');
        } else if (
          agent.current_call
          && state.notification.call_id !== agent.current_call.call_id
        ) {
          console.log('CALL CENTER ENTRO IF 3');
          commit('SET_NOTIFICATION', {
            ...agent.current_call,
            name: agent.current_call.full_name,
          });
          commit('SET_CALL_CENTER_STATUS', 3);
          commit('callTimeAndAlert/SET_CURRENT_STATUS_START_TIME', state.notification.answered_at ? moment.utc(state.notification.answered_at).unix() : moment.utc().unix(), { root: true });
          commit('ADD_CALL_TO_SAVE', {
            ...state.notification,
            max_commitment_days: state.maxCommitmentDays,
          });
          if (state.currentRecording.call_id !== agent.current_call.call_id) {
            commit('SET_CURRENT_RECORDING', {});
            commit('SET_IS_RECORDING', false);
          }
          if (agent.current_call.customer_id) {
            Vue.router.push(`/customers/${agent.current_call.customer_id}/show`);
          } else {
            Vue.router.push('/calls_lists/wait');
          }
        } else if (
          agent.current_call
          && state.notification.call_id === agent.current_call.call_id
          && state.notification.type_id === 7
          && (
            state.notification.customer_id !== agent.current_call.customer_id
            || (
              state.notification.fiscal_id !== agent.current_call.fiscal_id
              || state.notification.full_name !== agent.current_call.full_name
            )
          )
        ) {
          console.log('CALL CENTER ENTRO IF 4');
          commit('SET_NOTIFICATION', {
            ...agent.current_call,
            name: agent.current_call.full_name,
          });
          commit('ADD_CALL_TO_SAVE', {
            ...state.notification,
            max_commitment_days: state.maxCommitmentDays,
          });
          if (agent.current_call.customer_id) {
            Vue.router.push(`/customers/${agent.current_call.customer_id}/show`);
          }
        } else if (
          state.extensions.length > 0
          && state.extensions
            .filter(item => item.status_id === 5).length === state.extensions.length
        ) {
          console.log('CALL CENTER ENTRO IF 5');
          keepTrying = false;
          EventBus.$emit('modal', 'No hay llamadas pendientes');
          commit('SET_KEEP_CALLING', false);
          commit('SET_DISCONNECT_REASON', 'Sin llamadas');
          dispatch('disconnectCallCenter');
        } else if (state.callCenterStatus === 1 && !state.keepCalling) {
          console.log('CALL CENTER ENTRO IF 6');
          keepTrying = false;
          dispatch('disconnectCallCenter');
        }
        if (keepTrying) {
          setTimeout(() => {
            dispatch('checkOperatorStatus');
          }, Math.max(0, 1700 - (response.config.metadata.duration * 1000)));
        }
      })
      .catch((error) => {
        commit('SET_RECONNECTING', true);
        console.log(error); // eslint-disable-line
        dispatch('checkOperatorStatus');
      });
  },
  startCallCenterZoom({ commit, dispatch }, body) {
    dispatch('startCallCenter', body).then((extension) => {
      if (extension) {
        commit('SET_CONFERENCE_ID', body.conference_id);
        commit('SET_CALL_TYPE', 'zoom');
        commit('SET_KEEP_CALLING', true);
        commit('SET_CALL_LIST_ID', body.call_list_id);
        commit('SET_MAX_COMMITMENT_DAYS', body.max_commitment_days);
        commit('SET_EXTENSION', extension);
        dispatch('checkOperatorStatus');
        EventBus.$emit('hideMenu');
        Vue.router.push('/calls_lists/wait');
      }
    }).catch(() => {});
  },
  startCallCenterSoftphone({ commit, dispatch }, body) {
    dispatch('startCallCenter', body).then(() => {
      commit('SET_CALL_TYPE', 'softphone');
      commit('SET_KEEP_CALLING', true);
      commit('SET_CALL_LIST_ID', body.call_list_id);
      commit('SET_MAX_COMMITMENT_DAYS', body.max_commitment_days);
      commit('SET_EXTENSION_NUMBER', body.extension_number);
      dispatch('checkOperatorStatus');
      EventBus.$emit('hideMenu');
      Vue.router.push('/calls_lists/wait');
    }).catch(() => {});
  },
  startCallCenterPredictive({ commit, dispatch }, body) {
    dispatch('startCallCenter', body).then((extension) => {
      if (extension) {
        commit('SET_CALL_TYPE', 'predictive');
        dispatch('registerExtension', extension)
          .then((softPhone) => {
            commit('SET_SOFT_PHONE', softPhone);
            dispatch('makeCall', {
              softPhone,
              phone: `C${extension.extension}`,
            }).then((call) => {
              commit('SET_EXTENSION', extension);
              commit('SET_CALL', call);
              commit('SET_KEEP_CALLING', true);
              commit('SET_CALL_LIST_ID', body.call_list_id);
              commit('SET_MAX_COMMITMENT_DAYS', body.max_commitment_days);
              dispatch('checkOperatorStatus');
              EventBus.$emit('hideMenu');
              Vue.router.push('/calls_lists/wait');
            });
          });
      }
    });
  },
  startManualV2({ state, commit, dispatch }, body) {
    commit('SET_MANUAL_CALL_LOADING', true);
    commit('callTimeAndAlert/SET_STATUS_MANUAL_CALL', true, { root: true });
    commit('callTimeAndAlert/SET_CURRENT_STATUS_START_TIME', state.notification.answered_at ? moment.utc(state.notification.answered_at).unix() : moment.utc().unix(), { root: true });
    dispatch('callTimeAndAlert/getCallDurationData', null, { root: true });
    Vue.axios.post('customers/call_v2', {
      customer_id: body.customer_id,
      extension: body.extension_number,
      phone: body.phone,
      new_server: body.new_server,
    }).then((response) => {
      if (response.data.code && response.data.message) {
        EventBus.$emit('modal', response.data.message);
      } else {
        commit('SET_CALL_TYPE', 'manual_v2');
        commit('SET_EXTENSION_NUMBER', body.extension_number);
        commit('SET_NOTIFICATION', {
          ...response.data,
          name: `${response.data.name || response.data.first_name}${!response.data.name && response.data.last_name ? ` ${response.data.last_name}` : ''}`,
          phone: response.data.to,
        });
        commit('ADD_CALL_TO_SAVE', state.notification);
      }
    }).catch((error) => {
      if ((error.response || {}).status === 422) {
        // El 422 puede ser por falta de proveedor manual, usuario ya en llamada, etc.
        const apiMessage = ((error.response || {}).data || {}).message;
        EventBus.$emit('modal', apiMessage || 'Error, usuario conectado a campaña de call center.');
      }
    }).finally(() => commit('SET_MANUAL_CALL_LOADING', false));
  },
  startManual({ state, commit, dispatch }, body) {
    commit('SET_MANUAL_CALL_LOADING', true);
    commit('callTimeAndAlert/SET_STATUS_MANUAL_CALL', true, { root: true });
    commit('callTimeAndAlert/SET_CURRENT_STATUS_START_TIME', state.notification.answered_at ? moment.utc(state.notification.answered_at).unix() : moment.utc().unix(), { root: true });
    dispatch('callTimeAndAlert/getCallDurationData', null, { root: true });
    return dispatch('getFreeExtension')
      .then((extension) => {
        dispatch('registerExtension', extension)
          .then((softPhone) => {
            commit('SET_SOFT_PHONE', softPhone);
            Vue.axios.post('customers/call', {
              customer_id: body.customer_id,
              phone: body.phone,
            }).then((response) => {
              commit('SET_CALL_TYPE', 'manual');
              commit('SET_NOTIFICATION', {
                ...response.data,
                name: `${response.data.name || response.data.first_name}${!response.data.name && response.data.last_name ? ` ${response.data.last_name}` : ''}`,
                phone: response.data.to,
              });

              dispatch('makeCall', {
                phone: body.phone,
                softPhone: state.softPhone,
                headers: [
                  `X-Notification: ${response.data.id}`,
                  `X-Trunk: ${extension.trunk.name_asterisk}`,
                  `X-Prefix: ${extension.trunk.prefix || ''}`,
                  `X-Callerid: ${extension.caller_id.number}`,
                  `X-Driver: ${extension.trunk.driver}`,
                ],
              }).then((call) => {
                call.on('ended', () => {
                  commit('ADD_CALL_TO_SAVE', {
                    ...state.notification,
                    max_commitment_days: state.maxCommitmentDays,
                  });
                  dispatch('callFinished');
                });
                call.on('confirmed', () => {
                  commit('SET_NOTIFICATION', {
                    ...state.notification,
                    answered_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                  });
                });
                call.on('failed', () => {
                  commit('ADD_CALL_TO_SAVE', {
                    ...state.notification,
                    max_commitment_days: state.maxCommitmentDays,
                  });
                  dispatch('callFinished');
                });
                commit('SET_CALL', call);
                commit('SET_MANUAL_CALL_LOADING', false);
              });
            }).catch((error) => {
              commit('SET_MANUAL_CALL_LOADING', false);
              if ((error.response || {}).status === 422) {
                EventBus.$emit('modal', 'Error, usuario conectado a campaña de call center.');
              }
            });
          }).catch(() => commit('SET_MANUAL_CALL_LOADING', false));
      }).catch(() => commit('SET_MANUAL_CALL_LOADING', false));
  },
  setMute({ state }, body) {
    if (body) {
      state.call.mute({
        audio: true,
      });
    } else {
      state.call.unmute({
        audio: true,
      });
    }
  },
  hangup({ dispatch, state, commit }) {
    let result;
    if (state.callType !== 'manual' && state.callType !== 'manual_v2') {
      result = Vue.axios.post('extensions/hangup', {
        channel_id: state.notification.call_id,
      });
      dispatch('stopCallRecording');
    } else if (state.callType === 'manual_v2') {
      result = Vue.axios.post('extensions/hangup', {
        channel_id: state.notification.id,
      }).then(() => {
        dispatch('resetValues').then(() => {
          EventBus.$emit('update');
        });
        dispatch('stopCallRecording');
      });
    } else {
      if (state.call) {
        state.call.terminate();
        commit('callTimeAndAlert/SET_STATUS_MANUAL_CALL', false, { root: true });
      }
      result = Promise.resolve();
    }
    return result;
  },
  unregisterSoftPhone({ state }) {
    try {
      if (state.callType === 'predictive' && Object.keys(state.call).length > 0) {
        state.call.terminate();
      }
      state.softPhone.unregister({
        all: true,
      });
    } catch (e) {
      console.error('Error al desregistrar ', e); // eslint-disable-line
    }
  },
  // Procesos para el boton de grabacion
  startCallRecording({ state, commit }, call) {
    Vue.axios.post(`call/recordings/start/${call.id}`, {
      call_list_id: state.callListId || null,
      extension: state.extensionNumber,
      phone: call.phone,
      local_date: moment().format('YYYY-MM-DD'),
      customer_id: call.customer_id,
    }).then(({ data }) => {
      if (data.id) {
        commit('START_CALL_RECORDING', data.id);
      } else {
        EventBus.$emit('modal', 'Error al comenzar a grabar, por favor intente nuevamente');
      }
    }).catch(() => EventBus.$emit('modal', 'Error al comenzar a grabar, por favor intente nuevamente'));
  },
  stopCallRecording({ state, commit }) {
    if (state.callRecordingState) {
      Vue.axios.post(`call/recordings/hangup/${state.callRecordingId}`).then(() => {
        commit('STOP_CALL_RECORDING');
      }).catch(() => EventBus.$emit('modal', 'Error al detener la grabacion, por favor intente nuevamente'));
    }
  },
  getCallRecording({ state, dispatch }) {
    if (!state.callRecordingState) {
      Vue.axios.get('call/recordings').then(({ data }) => {
        // eslint-disable-next-line no-param-reassign
        if (data && data.keep_recording) {
          dispatch('setCallRecording', data);
        }
      }).catch(() => {});
    }
  },
  setCallRecording({ state, commit, dispatch }, recording) {
    if (state.callRecordingState) {
      dispatch('stopCallRecording');
    } else {
      commit('SET_CALL_RECORDING', recording);
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/dialer/moduleDialerActions.js